module.exports = __webpack_public_path__ + "img/10spades.4c992278.jpg";